<template>
  <v-container>
    <v-layout>
      <v-flex
        xs12
        lg10
        offset-lg1
        xl8
        offset-xl2
      >
        <v-container
          grid-list-lg
          px-0
        >
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              offset-xs0
              md6
              offset-md0
              lg5
              offset-lg0
            >
              <h3 class="headline mb-4">
                Nach Namen suchen
              </h3>
              <p class="subheading">
                Wenn Sie schon wissen, wen Sie suchen.
              </p>
              <div class="pl-0 pr-5">
                <v-autocomplete
                  v-model="model"
                  :items="items"
                  :loading="isLoading"
                  :search-input.sync="search"
                  clearable
                  hide-no-data
                  hide-details
                  cache-items
                  item-text="name"
                  item-value="slug"
                  @change="routerjumpto(model)"
                  placeholder="Hier suchen"
                  prepend-inner-icon="search"
                  return-object
                >
                  <template
                    slot="item"
                    slot-scope="data"
                  >
                    <template v-if="typeof data.item !== 'object'">
                      <v-list-tile-content>Leider nichts gefunden</v-list-tile-content>
                    </template>
                    <template v-else>
                      <v-list-tile-avatar v-if="data.item.innungen">
                        <img :src="data.item.innungen[0].logo">
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                        <v-list-tile-sub-title v-html="data.item.innungen[0].name">
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </template>
                </v-autocomplete>
             </div>
            </v-flex>
            <v-flex
              xs12
              md6
              offset-md0
              lg5
              offset-lg2
              style="xborder: 1px solid red;"
              :class="{'mt-5': $vuetify.breakpoint.smAndDown, 'mt-0': $vuetify.breakpoint.mdAndUp}"

            >
              
                <h3 class="headline mb-3">
                  Alle Fachbetriebe in Ihrer Nähe
                </h3>
                
                <p class="subheading">
                  Innungshandwerk ist vielfältig, erkunden Sie Ihre Umgebung.</p> 

                  <!-- <v-layout row>
                    <v-flex ><v-icon small  color="grey">info</v-icon></v-flex>
                    <v-flex> <p class="caption">
                  Aktuell im Beta-Test
                </p></v-flex>
                  </v-layout>
                -->
             

              <div class="xtext-xs-center pl-0 pr-5" style="xborder: 1px solid red;">
                <v-btn
                  large
                  block
                  outline
                  class="mt-2 ml-0"
                  :to="{name: 'indernaehe'}"
                >{{ KartenLabel }}<v-icon
                    right
                    large
                  >map</v-icon>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>

  <!-- 
  <v-container grid-list-lg>
    <v-layout>
      <v-flex
        xs12
        lg10
        offset-lg1
        xl8
        offset-xl2
      >

      <v-layout>
       
        <v-flex> 
          <h3 class="headline">Betriebe nach Namen suchen</h3>
          <br>  <v-btn
              large
              class="mt-3"
              :to="{name: 'indernaehe'}"
            >Alles in meiner Nähe</v-btn>
        </v-flex>

        <v-flex>
          <h3 class="headline">Alle Fachbetriebe in Ihrer Nähe zeigen</h3>
        </v-flex>
      </v-layout>
    
           
      </v-flex>
    </v-layout>
  </v-container> -->
</template>
  
<script>
import axios from 'axios'
export default {
  data: () => ({
    nameLimit: 60,
    entries: [],
    isLoading: false,
    model: null,
    search: null
  }),
  methods: {
    routerjumpto (betrieb) {
      if (betrieb) {
        this.$router.push({
          name: 'showCompany',
          params: { id: betrieb.slug }
        })
      }
    }
  },
  computed: {
    KartenLabel: function () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'Zu den Betrieben'
      } else {
        return 'Zur Karte'
      }
    },
    fields () {
      if (!this.model) return []

      return Object.keys(this.model).map(key => {
        return {
          key,
          value: this.model[key] || 'n/a'
        }
      })
    },
    items () {
      return this.entries.map(entry => {
        const name =
          entry.name.length > this.nameLimit
            ? entry.name.slice(0, this.nameLimit) + '...'
            : entry.name
        return Object.assign({}, entry, { name })
      })
    }
  },

  watch: {
    search (val) {
      // Items have already been loaded
      if (this.items.length > 0) return

      // Items have already been requested
      if (this.isLoading) return

      this.isLoading = true

      // Lazily load input items

      axios
        .get('/api/v1/getbetriebeautocomplete', {
          params: {
            query: this.model
          }
        })
        .then(response => {
          const entries = response.data
          this.entries = entries

          // this.info = response.data.bpi
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => (this.isLoading = false))

      // fetch('/api/v1/getbetriebeautocomplete')
      //   .then(res => res.json())
      //   .then(res => {

      //     console.log(res)

      //     const { count, entries } = res
      //     this.count = count
      //     this.entries = entries
      //   })
      //   .catch(err => {
      //     console.log(err)
      //   })
      //   .finally(() => (this.isLoading = false))
    }
  }
}
</script>